import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlaceholderItemComponent } from './placeholder-item/placeholder-item.component';
import { PlaceholderLoadingComponent } from './placeholder-loading.component';
import { PlaceholderRowComponent } from './placeholder-row/placeholder-row.component';

@NgModule({
  declarations: [
    PlaceholderLoadingComponent,
    PlaceholderRowComponent,
    PlaceholderItemComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PlaceholderLoadingComponent,
    PlaceholderRowComponent,
    PlaceholderItemComponent
  ]
})
export class PlaceholderLoadingModule { }
